import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MicrobiologyData } from './microbiology-data';

export const MICROBIOLOGY_DATA_STORAGE = new InjectionToken<MicrobiologyDataStorage>('MicrobiologyDataStorageToken');

export interface MicrobiologyDataStorage {
    siteMicrobiologyData: Observable<MicrobiologyData[]>;
}